import DiscountTagIcon from '@mui/icons-material/Loyalty'
import { Alert, AlertTitle } from '@mui/material'

import { i18WithDefault as t } from '@shared/locale'
import { APIBookingSearchClientDtoResponse } from 'service-api/src/types/api'
import { hasOffersDiscount } from './helper'

interface SearchOffersMembershipAlertProps {
  hasMembershipsService?: boolean
  searchResults?: APIBookingSearchClientDtoResponse['results']
  isOvernight?: boolean
}

export const SearchOffersMembershipAlert = ({
  hasMembershipsService,
  searchResults,
  isOvernight = false,
}: SearchOffersMembershipAlertProps) => {
  return hasMembershipsService && searchResults && hasOffersDiscount(searchResults, isOvernight) ? (
    <Alert icon={<DiscountTagIcon />} severity="info" sx={{ mb: 3 }}>
      <AlertTitle style={{ fontWeight: '600' }}>{t('searchResults.alert.membershipDiscount')}</AlertTitle>
    </Alert>
  ) : null
}
